export const calculateTargetFulfill = (current: number, target: number) => {
  if (target === 0) {
    return 0;
  }
  const percentage = (current / target) * 100;
  return Math.round(percentage);
};
